import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getComfortDetails } from "../../helpers/http_comforts_requests";
import { useQuery } from "@tanstack/react-query";

export default function ComfortDetails() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getComfortDetails', id], 
        queryFn: () => getComfortDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: comfortData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Conforto - Detalhes",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    return <DynamicFormPage 
        isLoading={isFetching} 
        details 
        initialData={comfortData} 
        title={"Conforto - Detalhes"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
    />;
}
